<template>
  <BaseAccordion
    v-model="activeKeys"
    :titles="titles"
  >
    <template #1>
      <BaseText>{{ $t('google_reserve.faq.answer_1') }}</BaseText>
      <BaseText href="https://www.google.com/business/">
        Google Business
      </BaseText>
    </template>
    <template #2>
      <BaseText>{{ $t('google_reserve.faq.answer_2', brandName()) }}</BaseText>
    </template>
    <template #3>
      <BaseText>
        <span v-html="$t('google_reserve.faq.answer_3', brandName())"></span>
      </BaseText>
    </template>
  </BaseAccordion>
</template>

<script
  setup
  lang="ts"
>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';

const { t } = useI18n();

const activeKeys = ref([]);
const titles = [
  t('google_reserve.faq.question_1'),
  t('google_reserve.faq.question_2'),
  t('google_reserve.faq.question_3'),
];
</script>
